import carecentreTokens from "./tokens";

const { color } = carecentreTokens;

/**
 * Zen editorial scrollbar — thin track, hairline thumb.
 * Replaces the legacy `glassScrollbar` mixin. Spread into a makeStyles rule
 * on any scroll container: `{ overflowY: "auto", ...ccScrollbar }`.
 */
export const ccScrollbar = {
  "&::-webkit-scrollbar": {
    width: 8,
    height: 8,
  },
  "&::-webkit-scrollbar-track": {
    background: "transparent",
  },
  "&::-webkit-scrollbar-thumb": {
    background: color.lineStrong,
    borderRadius: 4,
    "&:hover": {
      background: color.textQuiet,
    },
  },
  scrollbarWidth: "thin",
  scrollbarColor: `${color.lineStrong} transparent`,
};

export default ccScrollbar;
